import { debounce } from 'throttle-debounce';

export function scrollToTopWithCallback(onScrollEnds: VoidFunction, scrollTopOffset = 0): void {
  if (window.scrollY === scrollTopOffset) {
    onScrollEnds();

    return;
  }

  const handler = debounce(50, () => {
    onScrollEnds();

    document.removeEventListener('scroll', handler);
  });

  document.addEventListener('scroll', handler);

  window.scrollTo({ behavior: 'smooth', top: scrollTopOffset });
}
